function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.65,18.75c-3.77-1-5-2-5-3.56,0-1.81,1.67-3.07,4.47-3.07,3,0,4,1.41,4.14,3.48H29a6.59,6.59,0,0,0-5.32-6.31V5.66h-5V9.24c-3.21.7-5.8,2.78-5.8,6,0,3.83,3.17,5.74,7.79,6.84,4.14,1,5,2.46,5,4,0,1.14-.81,3-4.47,3-3.41,0-4.76-1.52-4.94-3.48H12.57c.19,3.63,2.91,5.67,6.09,6.35v3.6h5V31.92c3.24-.61,5.8-2.48,5.8-5.88,0-4.7-4-6.31-7.78-7.29",
    style: {
      fill: "#62a3ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollIcon);
export default __webpack_public_path__ + "static/media/payroll_icon.8b84938845768895e904d02a05bca767.svg";
export { ForwardRef as ReactComponent };